export const DATA_EXPORT_DATASETS = {
    CALLS: "calls",
    TRANSCRIPTS: "transcripts",
    LEAD_SCORES: "leadScores",
} as const;

export const DATA_EXPORT_DATASET_ORDER = [
    DATA_EXPORT_DATASETS.CALLS,
    DATA_EXPORT_DATASETS.TRANSCRIPTS,
    DATA_EXPORT_DATASETS.LEAD_SCORES,
] as const;

export const DATA_EXPORT_DATASET_LABEL_KEYS = {
    [DATA_EXPORT_DATASETS.CALLS]: "call_exports_dataset_calls",
    [DATA_EXPORT_DATASETS.TRANSCRIPTS]: "call_exports_dataset_transcripts",
    [DATA_EXPORT_DATASETS.LEAD_SCORES]: "call_exports_dataset_lead_scores",
} as const;

export const DATA_EXPORT_FILENAME_SLUGS = {
    [DATA_EXPORT_DATASETS.CALLS]: "calls",
    [DATA_EXPORT_DATASETS.TRANSCRIPTS]: "calls-with-transcripts",
    [DATA_EXPORT_DATASETS.LEAD_SCORES]: "lead-scores",
} as const;

export const DATA_EXPORT_FILE_EXTENSION = "json.gz";
